// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.18.1
//   protoc               v3.19.1
// source: xeam/common/xite_integration.proto

/* eslint-disable */

export const protobufPackage = "xeam.common";

export const protobufFileName = "xeam/common/xite_integration.proto";

export enum XiteIntegration {
  UNSPECIFIED = 0,
  BATTERY = 1,
  METERING_POINT_CONSUMPTION = 2,
  ELECTRICITY_CONTRACT = 3,
  ELOVERBLIK = 4,
}
